var _rect, _rect2, _path, _path2, _circle, _g, _circle2, _rect3, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _rect4, _rect5, _rect6, _rect7, _path13, _path14;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcInstall1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 312,
    height: 160,
    viewBox: "0 0 312 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 20.5,
    y: 21.5,
    width: 151,
    height: 88,
    rx: 2.5,
    fill: "white",
    stroke: "#909090"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 22.5,
    y: 23.5,
    width: 147,
    height: 84,
    rx: 1.5,
    fill: "white",
    stroke: "#909090"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44 109.5H35.2727L28 122.5H31.3939L44 109.5Z",
    stroke: "#909090"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M146 109.5H154.727L162 122.5H158.606L146 109.5Z",
    stroke: "#909090"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5311_44070",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 123,
    y: 56,
    width: 84,
    height: 84
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 165,
    cy: 98,
    r: 41.5,
    fill: "white",
    stroke: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5311_44070)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.5,
    y: 28.5,
    width: 161,
    height: 101,
    rx: 2.5,
    fill: "white",
    stroke: "#909090"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 165,
    cy: 98,
    r: 41.5,
    stroke: "#909090"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 173.5,
    y: 109.5,
    width: 23,
    height: 16,
    transform: "rotate(-90 173.5 109.5)",
    fill: "white",
    stroke: "#909090"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M188.885 117.5L188.885 78.5L289.403 78.5L292.494 98L289.403 117.5L188.885 117.5Z",
    fill: "white",
    stroke: "#909090"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M225.25 102.839L225.25 95.7968L228.407 95.7968C229.687 95.7968 230.632 96.1634 231.271 96.8538C231.859 97.4905 232.184 98.3523 232.184 99.3127C232.184 100.273 231.849 101.2 231.219 101.836C230.621 102.44 229.761 102.84 228.407 102.84L225.25 102.84L225.25 102.839ZM228.366 101.254C229.068 101.254 229.425 101.092 229.729 100.79C230.086 100.435 230.286 99.9922 230.286 99.3346C230.286 98.7199 230.107 98.2666 229.782 97.9109C229.477 97.5772 229.121 97.3829 228.366 97.3829L227.085 97.3829L227.085 101.255L228.366 101.255L228.366 101.254Z",
    fill: "#909090"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M231.857 102.839L235.036 95.7968H236.557L239.736 102.839H237.732L237.291 101.761H234.228L233.797 102.839H231.857ZM234.815 100.294H236.703L235.79 98.0404H235.727L234.814 100.294H234.815Z",
    fill: "#909090"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M244.919 97.7598C244.469 97.4898 243.608 97.0694 242.601 97.0694C242.045 97.0694 241.562 97.3284 241.562 97.7808C241.562 98.2769 242.349 98.3198 243.093 98.3955C244.352 98.4822 246.335 98.6545 246.335 100.573C246.335 102.353 244.909 103.054 243.188 103.054C241.468 103.054 240.22 102.375 239.391 101.749L240.377 100.466C240.849 100.811 241.94 101.577 243.156 101.577C244.006 101.577 244.499 101.199 244.499 100.736C244.499 100.229 243.911 100.132 243.03 100.056C241.499 99.9268 239.725 99.7654 239.725 97.8784C239.725 96.1319 241.309 95.5819 242.642 95.5819C244.047 95.5819 245.295 96.0671 245.915 96.4447L244.918 97.7608L244.919 97.7598Z",
    fill: "#909090"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M253.583 97.7598C253.133 97.4898 252.272 97.0694 251.265 97.0694C250.709 97.0694 250.226 97.3284 250.226 97.7808C250.226 98.2769 251.013 98.3198 251.758 98.3955C253.017 98.4822 254.999 98.6545 254.999 100.573C254.999 102.353 253.573 103.054 251.853 103.054C250.132 103.054 248.884 102.375 248.055 101.749L249.041 100.466C249.513 100.811 250.604 101.577 251.821 101.577C252.671 101.577 253.163 101.199 253.163 100.736C253.163 100.229 252.576 100.132 251.695 100.056C250.163 99.9268 248.39 99.7654 248.39 97.8784C248.39 96.1319 249.973 95.5819 251.306 95.5819C252.711 95.5819 253.96 96.0671 254.579 96.4447L253.583 97.7608L253.583 97.7598Z",
    fill: "#909090"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M254.895 95.7968H261.252V97.3819H258.997V102.839H257.161V97.3819H254.895V95.7968Z",
    fill: "#909090"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M272.739 101.621C271.911 102.376 270.673 103.055 269.162 103.055C266.865 103.055 265.343 101.372 265.343 99.3131C265.343 97.2537 266.875 95.5819 269.11 95.5819C270.369 95.5819 271.648 96.0781 272.53 96.7894L271.429 98.0189C270.789 97.4799 269.961 97.167 269.341 97.167C268.072 97.167 267.254 98.1484 267.254 99.324C267.254 100.5 268.093 101.481 269.394 101.481C270.191 101.481 271.02 100.996 271.628 100.413L272.739 101.621Z",
    fill: "#909090"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M275.069 98.439L277.765 95.7968H280.094L277.189 98.5894L280.514 102.839H278.237L275.898 99.8089L275.069 100.618V102.84H273.223V95.7977H275.069V98.44V98.439Z",
    fill: "#909090"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M261.281 102.839H263.44L264.942 95.7968H262.783L261.281 102.839Z",
    fill: "#909090"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M265.456 93.3845H263.297L262.949 95.0145H265.108L265.456 93.3845Z",
    fill: "#909090"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 0.707096,
    y: -1.19209e-7,
    width: 6.65841,
    height: 6.65841,
    rx: 0.526316,
    transform: "matrix(0.707096 -0.707118 0.707096 0.707117 195.311 98.5)",
    stroke: "#909090"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 0.707096,
    y: -1.19209e-7,
    width: 6.65841,
    height: 6.65841,
    rx: 0.526316,
    transform: "matrix(0.707096 -0.707118 0.707096 0.707117 202.205 91.6074)",
    stroke: "#909090"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 0.707096,
    y: -1.19209e-7,
    width: 6.65841,
    height: 6.65841,
    rx: 0.526316,
    transform: "matrix(0.707096 -0.707118 0.707096 0.707117 202.205 105.393)",
    stroke: "#909090"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 0.707096,
    y: -1.19209e-7,
    width: 6.65841,
    height: 6.65841,
    rx: 0.526316,
    transform: "matrix(0.707096 -0.707118 0.707096 0.707117 209.096 98.5)",
    stroke: "#909090"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M149 109V88C149 87.4477 149.448 87 150 87H155.107C155.436 87 155.743 87.1612 155.93 87.4313L157.823 90.1689C157.938 90.336 158 90.5344 158 90.7376V106.659C158 106.919 157.899 107.168 157.719 107.355L155.453 109.696C155.264 109.89 155.005 110 154.734 110H150C149.448 110 149 109.552 149 109Z",
    stroke: "#13AE67"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M154 89H152V108H154L155 106V91.5L154 89Z",
    stroke: "#13AE67"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcInstall1);
export default __webpack_public_path__ + "static/media/ic-install-1.5732feef839fca9fa73ca66d239bd415.svg";
export { ForwardRef as ReactComponent };